export default {
  path: '/coach',
  name: 'Coach',
  redirect: '/coach/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      component: () => import('@/views/coach'),
      meta: { requiresAuth: true }
    },
    {
      path: 'info',
      component: () => import('@/views/coach/Info'),
      meta: { requiresAuth: true }
    },
    {
      path: 'tutorial',
      component: () => import('@/views/coach/CoachTutorial'),
      meta: { requiresAuth: true }
    }
  ]
}
